import { render, staticRenderFns } from "./NavigationBarModalMenu.vue?vue&type=template&id=c021996c&scoped=true&"
import script from "./NavigationBarModalMenu.vue?vue&type=script&lang=js&"
export * from "./NavigationBarModalMenu.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarModalMenu.vue?vue&type=style&index=0&id=c021996c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c021996c",
  null
  
)

export default component.exports